import { render } from "./background-circle.vue?vue&type=template&id=4307e712&scoped=true"
import script from "./background-circle.vue?vue&type=script&lang=js"
export * from "./background-circle.vue?vue&type=script&lang=js"

import "./background-circle.vue?vue&type=style&index=0&id=4307e712&scoped=true&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/hkust-gz-vitals/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4307e712"]])

export default __exports__